import React from 'react';

interface GidiIconProps {
  size?: number;
  className?: string;
}

const GidiIcon: React.FC<GidiIconProps> = ({ size = '20px', className = '' }) => {
  return (
    <img
      src="/Gidi Icon.png"
      alt="Gidi"
      className={`gidi-icon ${className}`}
      style={{
        width: 28,
        height: 28,
        objectFit: 'contain',
        filter: 'brightness(1)',
        transition: 'filter 0.3s ease'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.filter = 'brightness(0.85)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.filter = 'brightness(1)';
      }}
    />
  );
};

export default GidiIcon;
